import Spinner from 'react-bootstrap/Spinner';

function Loader() {

    return <Spinner animation="grow" style={{width: '150px', height: '150px', marginTop: '100px'}}/>;
}

export default Loader;